import React, { useState } from "react";

interface CategoryModalProps {
  generateNewWord: Function;
}

export const CategoryModal = ({ generateNewWord }: CategoryModalProps) => {
  const [category, setCategory] = useState("Animals");
  const [isShowing, setIsShowing] = useState(true);
  const handleSubmit = (e: any) => {
    e.preventDefault();
    generateNewWord(category);
    setIsShowing(false);
  };

  if (!isShowing) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="border-b px-6 py-4">
          <h2 className="text-xl font-semibold">Choose a Category:</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="px-6 py-4 space-y-3">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                checked={category === "Animals"}
                value="Animals"
                onChange={() => setCategory("Animals")}
                className="form-radio"
              />
              <span>Animals</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                checked={category === "Car Manufacturers"}
                value="Car Manufacturers"
                onChange={() => setCategory("Car Manufacturers")}
                className="form-radio"
              />
              <span>Car Manufacturers</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                checked={category === "Pokemon"}
                value="Pokemon"
                onChange={() => setCategory("Pokemon")}
                className="form-radio"
              />
              <span>Pokemon</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                checked={category === "Colors"}
                value="Colors"
                onChange={() => setCategory("Colors")}
                className="form-radio"
              />
              <span>Colors</span>
            </label>
          </div>
          <div className="border-t px-6 py-4">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
